<template>
  <div class="layout-topbar" v-if="this.$store.state.auth.status.loggedIn">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <button
      class="p-link layout-menu-button"
      aria-label="Mostrar/Ocultar menu"
      @click="onMenuToggle"
      v-tooltip="'Mostrar/Ocultar menu'"
    >
      <span class="pi pi-bars"></span>
    </button>
    <div class="layout-topbar-icons">
      <button
        type="button"
        class="p-link topbar-icon-button p-mr-4"
        aria-label="Feriados, Aniversários e Ausentes"
        v-tooltip.left="'Feriados, Aniversários e Ausentes'"
        @click="$emit('toggle-who-is-out')"
      >
        <i class="pi pi-gift" aria-hidden="true"></i>
      </button>

      <button
        v-if="can('seeFreeTimesSupport')"
        type="button"
        class="p-link topbar-icon-button p-mr-4"
        :aria-label="freeTimesLabel"
        :aria-expanded="freeTimesOpen ? 'true' : 'false'"
        aria-controls="free-times-panel"
        v-tooltip.left="freeTimesLabel"
        @click="$emit('toggle-free-times')"
      >
        <i class="pi pi-clock" aria-hidden="true"></i>
        <span v-if="freeTimesCount" class="layout-topbar-badge" aria-hidden="true">
          {{ freeTimesCount > 99 ? "99+" : freeTimesCount }}
        </span>
      </button>

      <button class="p-link" aria-label="Logout" @click="logout()" v-tooltip.left="'Logout'">
        <span class="layout-topbar-icon pi pi-sign-out"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /** Technicians without bookings not yet marked read. */
    freeTimesCount: {
      type: Number,
      default: 0,
    },
    /** Whether their panel is open, for `aria-expanded`. */
    freeTimesOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    freeTimesLabel() {
      return this.freeTimesCount
        ? `Técnicos sem marcações: ${this.freeTimesCount} por ver`
        : "Técnicos sem marcações";
    },
  },
  methods: {
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
  },
};
</script>
<style scope>
.p-tooltip {
  z-index: 1000 !important;
}
.layout-topbar {
  z-index: 1000 !important;
}
/*
 * The top bar's buttons: at least 32x32 to click (the icons alone were
 * about 21x23), centred on the same line as before.
 */
.layout-topbar .layout-menu-button,
.layout-topbar .layout-topbar-icons button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
  margin-top: -6px;
  vertical-align: top;
}
.layout-topbar .layout-topbar-icons .topbar-icon-button {
  margin-left: 0;
}
.layout-topbar .layout-topbar-icons .topbar-icon-button .pi {
  font-size: 20px;
}
</style>
